import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/globals.css';

if (import.meta.env.DEV) {
  void (async () => {
    const React = await import('react');
    const ReactDOM = await import('react-dom');
    const axe = (await import('@axe-core/react')).default;
    axe(React, ReactDOM, 1000);
  })();
}

const root = document.getElementById('root');
if (!root) throw new Error('#root element missing');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
